import { useState } from 'react';
import { useNavigate } from 'react-router';
import { handlePaymentScreenAction } from '../../../Helpers/functions';

interface WidgetProps {
    widget : any,
    paymentSecret : string
    cartId : string
    modelId : string
    referrerUrl : string
}
const Button = ({widget,paymentSecret,cartId,modelId,referrerUrl} : WidgetProps) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNextAction = () => {
        handlePaymentScreenAction({paymentSecret,cartId,modelId,widget,setLoading,navigate,referrerUrl})
    }
   
    return <div className='text-center border-0 shadow-sm mt-3'>
            <button className='btn w-100 fw-bold' style={{fontSize:"16px",backgroundColor : `${widget.background}`, color :`${widget.textColor}`}} onClick={handleNextAction} disabled={loading}>
            {loading ? ( <span className="spinner-border spinner-border-md" role="status" aria-hidden="true"></span>) : <>{widget.label} <img height="24" src={widget.image.replace("{platform}","android").replace("{size}","h")}/></>}
        </button>
    </div>
}

export default Button;